const tasks = [
  { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Повышаем конверсию на каждом этапе воронки: от первого контакта до закрытия сделки.' },
  { icon: 'ri-percent-line', title: 'Сокращение скидок', desc: 'Учим продавать ценность продукта, аргументировать цену и избегать необоснованных уступок.' },
  { icon: 'ri-discuss-line', title: 'Развитие переговорных навыков', desc: 'Сложные переговоры с ЛПР, закупщиками и тендерными комитетами — уверенно и с результатом.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Повышение среднего чека', desc: 'Техники допродаж, кросс-сейла и апсейла для увеличения дохода с каждого клиента.' },
  { icon: 'ri-building-2-line', title: 'Развитие B2B продаж', desc: 'Адаптируем стратегию под длинный цикл сделки, работу с несколькими ЛПР и высокую стоимость решения.' },
  { icon: 'ri-phone-line', title: 'Телефонные продажи', desc: 'Обучаем уверенной работе по телефону: от холодного звонка до закрытия сделки по телефону.' },
  { icon: 'ri-chat-1-line', title: 'Продажи через переписку', desc: 'Telegram, WhatsApp, CRM и e-mail — учим вести результативную деловую переписку с клиентами.' },
  { icon: 'ri-user-heart-line', title: 'Удержание клиентов', desc: 'Выстраиваем долгосрочные отношения, повышаем LTV и снижаем отток клиентской базы.' },
  { icon: 'ri-chat-check-line', title: 'Работа с возражениями', desc: 'Алгоритмы обработки типовых и нестандартных возражений без споров и потери клиента.' },
  { icon: 'ri-search-eye-line', title: 'Выявление потребностей', desc: 'Методики SPIN, глубинного интервью и навыки задавать правильные вопросы письменно и устно.' },
  { icon: 'ri-shield-star-line', title: 'Переговоры руководителей', desc: 'Развиваем стратегическое мышление руководителей для сложных сделок и партнёрских переговоров.' },
  { icon: 'ri-settings-3-line', title: 'Построение системы продаж', desc: 'От хаотичных усилий — к прозрачной, управляемой и масштабируемой системе продаж компании.' },
];

export default function TasksSolved() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Какие задачи решает корпоративное обучение продажам
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Системное обучение продажам и переговорам закрывает все этапы цикла продаж и даёт измеримый рост бизнес-показателей
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tasks.map((task, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className={`${task.icon} text-base text-white`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-teal-700 transition-colors">
                    {task.title}
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{task.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}